// extracted by mini-css-extract-plugin
module.exports = {"NavigationLink":"NavigationLink_NavigationLink__aqOTe","activeLink":"NavigationLink_activeLink__2rPow"};